import { CartLinesUpdateEvent } from '@shopify/events';
/* Integrates cart add-ons with Horizon's own section renderer and cart icon. */
if (!window.lkAddonNativeBound) {
  window.lkAddonNativeBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof Element ? event.target.closest('[data-lk-addon-form]') : null;
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const variantId = form.querySelector('input[name="id"]')?.value;
    if (!variantId) return;
    const root = window.Shopify?.routes?.root || '/';
    const announce = (message) => {
      const live = document.querySelector('#lk-addon-status');
      if (live) live.textContent = message;
    };
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    announce('Adding guide…');
    let added = false;
    try {
      const fd = new FormData(form);
      const add = await fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const addedResult = await add.json();
      if (!add.ok || addedResult.status) throw new Error(addedResult.description || 'Could not add this guide');
      added = true;
      announce('Guide added. Updating your cart…');
      let sections;
      let discountWarning = '';
      try {
        const discountCodes = Array.from(document.querySelectorAll('#cart-drawer .cart-discount__pill'))
          .map((pill) => pill instanceof HTMLLIElement ? pill.dataset.discountCode : null)
          .filter((code) => typeof code === 'string' && code.trim());
        if (!discountCodes.includes('ADDON499')) discountCodes.push('ADDON499');
        const update = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: [...new Set(discountCodes)].join(','), sections: ['cart-drawer-section'], sections_url: window.location.pathname })
        });
        if (!update.ok) throw new Error('Discount request failed');
        const data = await update.json();
        sections = data.sections;
      } catch (error) {
        discountWarning = ' ADDON499 was not confirmed; check the discount at checkout.';
      }
      const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!cartResponse.ok) throw new Error('Could not refresh cart information');
      const cart = await cartResponse.json();
      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferred.promise
      }));
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: false, items: cart.items, sections, itemCount: cart.item_count, source: 'lk-cart-addon' }
      });
      announce('Guide added to cart.' + discountWarning);
      button.removeAttribute('aria-busy');
    } catch (error) {
      if (added) {
        announce('Guide was added, but cart refresh could not be confirmed. Close and reopen the cart to check before adding again.');
      } else {
        announce(error.message || 'Could not add guide. Try again.');
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  }, true);
}
